import React, {Component} from 'react';
import { FormattedMessage } from 'react-intl';

import {STRIPE_CARD} from "../constants/paymentTypes";

//Lodash
import _assign from 'lodash/assign';

import {
    CardElement,
    injectStripe,
} from 'react-stripe-elements';

import RaisedButton from 'material-ui/RaisedButton';
import muiThemeable from "material-ui/styles/muiThemeable";

class _StripeCardForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
          disabled: this.props.isPaying
        };

        this.getStyles = () => {
            return {
                'buyButton': this.props.muiTheme.buyButton,
                'buyButtonInside': this.props.muiTheme.buyButtonInside,
            }
        };
    }

    componentWillReceiveProps(nextProps){
        this.setState({disabled: nextProps.isPaying});
    }

    handleCreateToken = () => {

        this.setState({disabled: true});

        //We send the name if it's there
        let data = {};
        if (this.props.nameOnCard) {
            data = _assign(data, {'name': this.props.nameOnCard})
        }

        this.props.stripe.createToken(data)
            .then(payload => {
                    if (payload.token) {
                        this.props.handleToken(payload.token, STRIPE_CARD)
                    } else if (payload.error) {
                        this.props.handleError(payload.error);
                        this.setState({disabled: false});
                    }
                }
            );
    };

    render() {

        const styles = this.getStyles();

        return (
            <div className="clear">
                <CardElement className="cardElement" />
                <RaisedButton
                    type="submit"
                    label={
                        <FormattedMessage
                            id="checkout.payNow"
                            defaultMessage="Pay"
                        />
                    }
                    className="buyBtn"
                    backgroundColor="#808080"
                    disabled={this.state.disabled}
                    style={styles.buyButton}
                    buttonStyle={styles.buyButtonInside}
                    onClick={this.handleCreateToken}
                    primary
                />
            </div>
        )
    }
}

export const StripeCardForm = muiThemeable()(injectStripe(_StripeCardForm));